import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/content";

const iconTints = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-100 text-secondary-800",
];

export default function CategoryOverview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <SectionHeading
        id="overview"
        eyebrow="Content Types"
        title="神马电影网的内容类型总览"
        description="从电影到电视剧，从最新电影到热播剧，再从欧美大片到国产剧，六个方向覆盖了绝大多数浏览需求。先了解每个方向包含什么，再决定从哪里开始看。"
      />

      <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((item, index) => (
          <article
            key={item.id}
            className="group rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <div className="flex items-start justify-between gap-3">
              <span
                className={`w-11 h-11 rounded-md flex items-center justify-center ${iconTints[index % iconTints.length]}`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs">
                {item.count}
              </span>
            </div>
            <h3 className="mt-4 text-lg font-semibold text-foreground-950">{item.name}</h3>
            <p className="mt-2 text-sm leading-7 text-foreground-600">{item.desc}</p>
            <div className="mt-4 pt-4 border-t border-background-200 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-price-tag-3-line text-accent-500"></i>
              {item.examples}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}